import type { provideTransloco } from '@jsverse/transloco';

import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '../../config/locales';

/** Transloco configuration accepted by `provideTransloco`. */
export type FuryTranslocoConfig = NonNullable<Parameters<typeof provideTransloco>[0]['config']>;

/** Domains loaded at startup for every language; the other catalogs are lazy feature scopes. */
export const GLOBAL_CATALOG_DOMAINS = ['common', 'errors', 'layout'] as const;

/**
 * Builds the Transloco configuration. Missing keys are reported in the console only in
 * development builds, and Spanish is the fallback for any key a language lacks.
 *
 * @param devMode True for a development build (`isDevMode()`).
 */
export function buildTranslocoConfig(devMode: boolean): FuryTranslocoConfig {
  return {
    availableLangs: SUPPORTED_LOCALES.map((locale) => locale.code),
    defaultLang: DEFAULT_LOCALE,
    fallbackLang: DEFAULT_LOCALE,
    reRenderOnLangChange: true,
    prodMode: !devMode,
    failedRetries: 0,
    missingHandler: { logMissingKey: true, useFallbackTranslation: true },
  };
}
